/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { OverflowCarousel } from '@coursera-web/cds-labs';

import type { PageConfigComponent as PageConfigComponentTrackingData } from '@coursera/event-pulse-types';

import PartnerLogo, { type PartnerLogoData } from 'bundles/unified-common/components/partner-logos/PartnerLogo';

const styles = {
  pills: css`
    display: flex;
    gap: var(--cds-spacing-100);
    flex-wrap: nowrap;
  `,
};

type Props = {
  partners: PartnerLogoData[];
  pageConfigComponentTrackingData?: PageConfigComponentTrackingData;
};

const PartnerLogosComponent = (props: Props) => {
  const { partners, pageConfigComponentTrackingData } = props;
  return (
    <OverflowCarousel css={styles.pills} shouldAllowSpaceForHoverItems shouldStartOverflowAtMediumBreakpoint>
      {partners.map((partner) => (
        <PartnerLogo
          key={partner.name}
          name={partner.name}
          logo={partner.logo}
          href={partner.href}
          pageConfigComponentTrackingData={pageConfigComponentTrackingData}
        />
      ))}
    </OverflowCarousel>
  );
};

export default PartnerLogosComponent;
